import http from "../http-common";

class FastQuotingCabinetVersionDataService {
  getAll(condition) {
    return http.get(`/fastquotingcabinetversions/search/?fastquotingcabinetId=${condition}`);
  }

  getFastQuotingCabinetVersionsByDescr(condition,fastquotingcabinetversionnumber,sortfield,sorttype) {
    return http.get(`/fastquotingcabinetversions/search/?fastquotingcabinetId=${condition}&fastquotingcabinetversionnumber=${fastquotingcabinetversionnumber}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }  

  getCondition(condition) {
    return http.get(`/fastquotingcabinetversions/search/?fastquotingcabinetversion=${condition}`);
  }

  get(id) {
    return http.get(`/fastquotingcabinetversions/${id}`);
  }

  findById(id) {
    return http.get(`/fastquotingcabinetversions/${id}`);
  }  

  create(data) {
    return http.post("/fastquotingcabinetversions", data);
  }

  update(id, data) {
    return http.put(`/fastquotingcabinetversions/${id}`, data);
  }

  delete(id) {
    return http.delete(`/fastquotingcabinetversions/${id}`);
  }

  deletewhere(id) {
    return http.delete(`/fastquotingcabinetversions/where/${id}`);
  }  

  deleteAll() {
    return http.delete(`/fastquotingcabinetversions/items`);
  }


//////////////////////////////////////////////////////////////////////////////////////////////////////////////

}

export default new FastQuotingCabinetVersionDataService();